<template>
  <div
    class="login"
    id="loginDiv"
    v-loading="loading"
    element-loading-text="登录中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-main class="loginBg">
      <div class="loginTop" style="height: 200px">
        <!-- <img src="~@/assets/img/LOGO1.png" alt /> -->
      </div>
      <div class="loginMiddle">
        <div class="midInputBox pos">
          <div class="midBox">
            <!-- <div class="login-left">
              <div class="left-title">用户管理</div>
              <div class="left-img">
                <img src="~@/assets/img/login-icon.png" alt />
              </div>
            </div> -->
            <div class="login-right">
              <div class="rightInput">
                <el-form label-width="100px">
                  <el-form-item label="用户名：" style="margin-bottom: 15px">
                    <el-input
                      @keyup.enter.native="hueiche"
                      v-model="loginUser.username"
                      placeholder="请输入用户名"
                      @keydown="keyEnter"
                    ></el-input>
                  </el-form-item>
                  <el-form-item class="password pos">
                    <span>密&nbsp;&nbsp;&nbsp;&nbsp;码：</span>
                    <el-input
                      @keyup.enter.native="hueiche"
                      type="password"
                      v-model="loginUser.password"
                      placeholder="请输入密码"
                      @keydown="keyEnter"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightBtn">
                <el-button class="rigBtn" @click="login()"
                >登&nbsp;&nbsp;录
                </el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loginFooter" style="letter-spacing: 2px">
        <p>使城市更安全&nbsp;&nbsp;&nbsp;百姓更幸福</p>
        <p>
          备案号：
          <a
            class="beianLink"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            >京ICP备2021005180号-1</a
          >
          <br/>
<!--          版权所有：北京零零易科技有限公司-->
        </p>
      </div>
    </el-main>
  </div>
</template>

<script>
import screenfull from "screenfull";
import {defaultStyleTp, LJStyleTp, redStyleTp} from "@/js/constants";

let _this;
export default {
  name: "Login",
  data() {
    return {
      loginUser: {username: "", password: ""},
      isFullscreen: false,
      pubkey: null,
      loading: false,
    };
  },
  created() {
    _this = this;
    //获取公钥
    _this.pubkeyData();
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 27) {
        _this.login();
      }
    };
    //获取域名地址
    _this.location();
  },
  methods: {
    pubkeyData() {
      let success = function (e) {
        if (e.code == "0") {
          _this.pubkey = e.data;
        } else {
          console.log("获取公钥失败！");
        }
      };
      this.http.get("/getPublicKeyStr", {}, success);
    },

    location() {
      let location = window.location.href;
      // location = 'https://www.00e.com/?id=cwjd123';
      let data = location.split("?")[1];
      if (!data) {
        return;
      } else {
        _this.loading = true;

        let account = data.split("id=")[1];
        if (
          (account && account == "cwjd123") ||
          (account && account == "cwjd")
        ) {
          //判断账号和密码都存在并且和来始页的账号和密码一致

          //运行获取公钥；
          _this.pubkeyData();

          setTimeout(function () {
            //公钥
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey(_this.pubkey);
            //加密
            var encryptedUsername = encrypt.encrypt("cwjd");
            var encryptedPassword = encrypt.encrypt("123456");

            let submit = {};
            submit.username = encryptedUsername;
            submit.password = encryptedPassword;

            var success = function (resp) {
              if (resp.code == "0") {
                var menuArr = [];
                if (resp.menu) {
                  menuArr = resp.serve.match(/\d+/g) || [];
                }

                let url = "";
                _this.$store.state.ref = resp.token;
                _this.$store.state.serve = resp.serve || []
                _this.$store.state.menu = menuArr;
                _this.$store.state.userId = resp.id;
                _this.$store.state.name = resp.userName;
                _this.$store.state.deptStatus = resp.deptStatus;
                _this.$store.state.isKeyUnit = resp.isKeyUnit;
                _this.$store.state.js = resp.js ? resp.js : "";
                _this.$store.state.username = "cwjd";
                _this.$store.state.password = "123456";
                _this.$store.state.yearsTitle =
                  "京ICP备2021005180号-1";
                _this.$root.eventHub.$emit("initWebsocket");
                let initView = true

                if (resp.deptStatus == "0") {
                  if (resp.js == "0") {
                    //支队
                    url = "/Street";
                  } else if (resp.js == "1") {
                    //运营
                    url = "/element";
                  } else if (resp.js == "2") {
                    //商务
                    url = "/structOrganize";
                  } else if (resp.js == "3") {
                    //库管
                    url = "/outPutInventory";
                  }
                } else if (resp.deptStatus == "1") {
                  if (resp.js == "1") {
                    // 中队防火检查员
                    initView = false
                    url = 'fxlq'
                  } else {
                  // 中队
                  url = "/Street";
                  }
                } else if (resp.deptStatus == "2") {
                  //微站
                  if (resp.isKeyUnit == "2") {
                    url = "/homeWz";
                  } else if (resp.isKeyUnit == "0" || resp.isKeyUnit == "1") {
                    url = "/home";
                  } else if (resp.isKeyUnit == "6") {
                    url = "/HomeConcise";
                  }
                } else if (resp.deptStatus == "3") {
                  //街道 litjd
                  if(resp.js == '2'){
                    //  大队防火员
                    // todo 链接待定
                    url = '/Street';
                  } else if (resp.js == '3') {
                    url = '/home-ljfl'
                    _this.$store.commit('updateStyleTp', LJStyleTp)
                  } else {
                    url = "/Street";
                  }
                } else if (resp.deptStatus == "4") {
                  //电动车登记
                  // url = "/carHome";
                  url = "/carManage";
                } else if (resp.deptStatus == "5") {
                  //重点户登记
                  url = "/volunteer";
                } else if (resp.deptStatus == "10") {
                  //伙伴管理
                  url = "/teamMap";
                } else {
                  _this.$message.warning("该角色下暂无页面！");
                  return;
                }
                _this.$store.commit('updateStyleTp', defaultStyleTp)
                _this.$router.push(url);
                console.log(initView, 'initView')
                initView && _this.click();
              } else {
                _this.$message.error(resp.msg);
              }
              _this.loading = false;
            };
            _this.http.post("/login", submit, success);
          }, 1500);
        }
      }
    },

    keyEnter() {
    },
    hueiche() {
      _this.login();
    },
    click() {
      if (!screenfull.enabled) {
        _this.$message({
          message: "you browser can not work",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },
    change() {
      _this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      _this.loginUser.username = _this.$store.state.username;
      _this.loginUser.password = _this.$store.state.password;
      if (_this.loginUser.username && _this.loginUser.password) {
        // _this.login();
      }
      if (screenfull.enabled) {
        screenfull.on("change", _this.change);
      }
    },
    destroy() {
      if (screenfull.enabled) {
        screenfull.off("change", _this.change);
      }
    },

    //登录
    login() {
      if (!_this.loginUser.username) {
        _this.$message.warning("请输入账号!");
        return;
      }
      if (!_this.loginUser.password) {
        _this.$message.warning("请输入密码!");
        return;
      }

      _this.loading = true;
      setTimeout(() => {
        var success1 = (res) => {
          console.log(res.data.status)
          let status = res.data.status
          if (status === '0') {
            this.login1()
            return
          }
          this.$confirm('系统检测该账号已登录，登陆将导致对方下线, 是否继续?', '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.login1()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消登录'
            });
            _this.loading = false;
          });
        }
        // 检测账号是否登录
        _this.http.post("/loginStatus", {username: _this.loginUser.username}, success1);
      }, 1500)
    },
    // 登录
    login1() {
      //公钥
      var encrypt = new JSEncrypt();
      encrypt.setPublicKey(_this.pubkey);
      //加密
      var encryptedUsername = encrypt.encrypt(_this.loginUser.username);
      var encryptedPassword = encrypt.encrypt(_this.loginUser.password);

      let submit = {};
      submit.username = encryptedUsername;
      submit.password = encryptedPassword;

      var success = function (resp) {
        if (resp.code === "0") {
          let menuArr = [];
          if (resp.menu) {
            menuArr = resp.serve.match(/\d+/g) || [];
          }
          //判断menu内是否有呼叫报警
          let num = menuArr.filter((v) => v == "20");
          // if (num > 0 && resp.deptStatus != "3") {
          if (num > 0) {
            //判断呼叫报警的sdk的账号
            if (!resp.shieldKingUserName) {
              _this.$message.warning(
                "请先配置该微站下呼叫报警设备的SDK账号！"
              );
              return;
            }

          }
          console.log("用户信息====", resp, resp.deptStatus === "3")
          _this.$store.state.sdkUserName = resp.shieldKingUserName;
          console.log("sdk账号====", _this.$store.state.sdkUserName)
          // 获取个街道菜单
          resp.deptStatus == "3" && _this.getJdMenuList();
          let url = "";
          _this.$store.state.ref = resp.token;
          _this.$store.state.serve = resp.serve || [];
          console.log(resp.serve, 'resp.serve')
          _this.$store.state.menu = menuArr;
          _this.$store.state.userId = resp.id;
          _this.$store.state.name = resp.userName;
          _this.$store.state.deptId = resp.deptId;
          _this.$store.state.deptStatus = resp.deptStatus;
          _this.$store.state.isKeyUnit = resp.isKeyUnit;
          _this.$store.state.js = resp.js ? resp.js : "";
          _this.$store.state.username = _this.loginUser.username;
          _this.$store.state.password = _this.loginUser.password;
          _this.$store.state.deviceIp = resp.deviceIp;
          _this.$store.state.deviceNum = resp.deviceNum;
          _this.$store.state.teShuBuMen = resp.teShuBuMen;
          _this.$store.state.yearsTitle =
            "京ICP备2021005180号-1";
          let submit = {};
          let initView = true
          let success1 = function (resp1) {
            if (resp1.code == "0") {
              _this.wzjs = resp1.data.descriptionNum;
              if (resp.deptStatus == "3" && resp.js == '3') {
                resp1.data.logoImgPath =  resp1.data.laJiLogoImgPath
                let serveArr = resp.serve ? resp.serve.match(/\d+/g) || [] : [];
                let permArr = ['33', '46', '47', '48'];
                if (serveArr.includes('49')) {
                  permArr.push('49');
                }
                if (serveArr.includes('52')) {
                  permArr.push('52');
                }
                _this.$store.state.serve = permArr;
                _this.$store.state.menu = permArr;
              } else {
                let serveArr = resp.serve ? resp.serve.match(/\d+/g) || [] : [];
                _this.$store.state.serve = serveArr.filter(v => v !== "33");
                _this.$store.state.menu = menuArr.filter(v => v !== "33");
              }
              _this.$store.dispatch("saveUserInfo", resp1.data); //请求回来后，把用户信息存储到VUEX里
              _this.$root.eventHub.$emit("initWebsocket");
              console.log(resp, '用户信息')
              _this.$store.commit('updateStyleTp', defaultStyleTp)
              if (resp.loginName === "xxxx") {
                // todo 楼宇消防隐患页面
                url = "/buildingAlarm";
              } else {
                if (resp.deptStatus == "0") {
                  if (resp.js == "0") {
                    //支队
                    url = "/Street";
                  } else if (resp.js == "1") {
                    //运营
                    url = "/element?login=true";
                    // url = "/element";
                  } else if (resp.js == "2") {
                    //商务
                    url = "/structOrganize";
                  } else if (resp.js == "3") {
                    //库管
                    url = "/outPutInventory";
                  }
                } else if (resp.deptStatus == "1") {
                  if (resp.js == "1") {
                    // 中队防火检查员
                    initView = false
                    url = 'fxlq'
                  } else {
                    // 中队
                    url = "/Street";
                  }
                } else if (resp.deptStatus == "2") {
                  if (resp.isKeyUnit == "2") {
                    url = "/homeWz";
                  } else if (resp.isKeyUnit == "0" || resp.isKeyUnit == "1") {
                    url = "/home";
                  } else if (resp.isKeyUnit == "6") {
                    url = "/HomeConcise";
                  }
                } else if (resp.deptStatus == "3") {
                  //街道 litjd
                  if(resp.js == '2'){
                    //  大队防火员
                    // todo 链接待定
                    url = '/Street';
                  } else {
                    url = "/Street";
                  }
                  if (resp.themeStyle === LJStyleTp || resp.js == '3') {
                    url = "/home-ljfl"
                    _this.$store.commit('updateStyleTp', LJStyleTp)
                  } else {
                    // url = "/home-channel"
                    url = "/wisdomIndex"
                  }
                  if (resp.themeStyle === redStyleTp && resp.js != '3') {
                    _this.$store.commit('updateStyleTp', redStyleTp)
                  }
                } else if (resp.deptStatus == "4") {
                  //电动车登记
                  // url = "/carHome";
                  url = "/carManage";
                } else if (resp.deptStatus == "5") {
                  //重点户登记
                  url = "/volunteer";
                } else if (resp.deptStatus == "10") {
                  //伙伴管理
                  url = "/teamMap";
                } else {
                  _this.$message.warning("该角色下暂无页面！");
                  return;
                }
              }
              _this.$router.push(url);
              initView && _this.click();
            }
          };
          _this.http.get(
            "/wxf/informationOfVillageResidents/getDeptDetail",
            submit,
            success1
          );
        } else {
          _this.$message.error(resp.msg);
        }

        _this.loading = false;
      };
      _this.http.post("/login", submit, success);
    },
    // 获取个街道菜单
    getJdMenuList() {
      let success = (res) => {
        let {data, code} = res;
        code == "0" && (_this.$store.state.jdMenuList = data);
      };

      // 		/sys/dept/getSubordinateDeptServeice
      // 街道获取每个服务对应的部门列表
      _this.http.get("/sys/dept/getSubordinateDeptServeice", {}, success);
    },
    // 获取用户数据
    wzjsData() {
      let submit = {};
      let success = function (resp) {
        if (resp.code == "0") {
          _this.wzjs = resp.data.descriptionNum;
          _this.$store.dispatch("saveUserInfo", resp.data); //请求回来后，把用户信息存储到VUEX里
        }
      };
      this.http.get(
        "/wxf/informationOfVillageResidents/getDeptDetail",
        submit,
        success
      );
    },
  },
};
</script>

<style lang="less">
.login {
  background-color: #101229;

  .el-main {
    padding: 0;
    box-sizing: border-box;
    height: 100vh;
    background-size: auto 100vh;
    position: relative;
    min-height: 800px;
  }

  .loginBg {
    background: url("~@/assets/img/login/loginBackground.png") no-repeat center center / cover;
    background-size: 100% 100%;
  }

  .loginTop {
    img {
      width: 21%;
      display: block;
      margin: auto;
      padding-top: 2.8%;
    }
  }

  .loginMiddle {
    height: 550px;
    // background: url("~@/assets/img/login-bg.png") no-repeat center center / cover;

    .midInputBox {
      top: 35px;
      left: 50%;
      margin-left: -175px;
      width: 350px;
      height: 350px;
      // background: linear-gradient(
      //   180deg,
      //   rgba(255, 222, 220, 0.55),
      //   rgba(255, 60, 57, 0.55)
      // );
      // border: 1px solid rgba(200, 122, 120, 1);
      // box-shadow: 1px 2px 8px 0px rgba(0, 0, 0, 0.31);
      // border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .pos {
      position: relative;
    }

    .midBox {
      height: 350px;
      overflow: hidden;

      .login-right {
        height: 100%;

        .rightInput {
          margin-top: 100px;

          .el-input__inner {
            height: 40px;
            border: 1px solid rgba(222, 45, 45, 1);
            font-size: 13px;
          }

          .el-form-item__label {
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(221, 44, 44, 1);
          }

          .password span {
            display: block;
            width: 100px;
            position: absolute;
            left: -98px;
            top: 0;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(221, 44, 44, 1);
          }
        }

        .rigBtn {
          padding: 0;
          text-align: center;
          margin: 57px auto 0px;
          display: block;
          cursor: pointer;
          width: 299px;
          height: 40px;
          line-height: 40px;
          background: rgba(214, 13, 11, 1);
          border-radius: 7px;
          font-size: 23px;
          color: rgba(229, 227, 238, 1);
        }
      }
    }
  }

  .loginFooter {
    width: 500px;
    height: 50px;
    text-align: center;
    margin: auto;
    margin-top: -80px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff; //rgba(51, 51, 51, 1);
    line-height: 30px;

    .beianLink {
      color: #ffffff;
      text-decoration: none;

      &:hover {
        color: #ffffff;
        text-decoration: underline;
      }
    }
  }
}

.login .loginMiddle .midBox .login-right .rightInput .el-input__inner {
  background: transparent;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/Login.vue